<div class="secondary-navigation" *ngIf="client$ | async as client">
    <ng-container *ngIf="!(collapsed$ | async)">
        <app-topnav (back)="back()" [heading]="client.Name"> </app-topnav>

        <app-topbar-info>
            <nav customNavInfo class="nav-list-container">
                <ul>
                    <li *ngIf="{ isTracking: isTracking$ | async, canEditCustomerType: canEditCustomerType$ | async } as data">
                        <div class="nav-cont">
                            <h6 class="title">Type</h6>
                            <ng-select
                                class="slim"
                                [disabled]="data.isTracking || !data.canEditCustomerType"
                                [items]="clientTypes$ | async"
                                placeholder="Client Type"
                                [clearable]="false"
                                [searchable]="false"
                                (change)="setType($event)"
                                [(ngModel)]="client.CustomerType">
                            </ng-select>
                        </div>
                    </li>
                </ul>
            </nav>
        </app-topbar-info>
    </ng-container>

    <div class="topbar-menu">
        <app-menubar id="menubar-client" [menuItems]="clientMenuItems"></app-menubar>
    </div>

    <app-menubar-scroll *ngIf="isMobile$ | async" [menuName]="menuName.Client"></app-menubar-scroll>
    <app-menubar-collapse></app-menubar-collapse>
</div>
